const fr = {
  // Nav
  nav_home: "Accueil",
  nav_about: "À propos",
  nav_services: "Services",
  nav_projects: "Réalisations",
  nav_contact: "Contact",
  nav_cta: "Demander un devis",

  // Home hero
  hero_subtitle: "Quality In Every Build",
  hero_description: "Construction · Travaux Publics · Transport & Logistique · Solutions Digitales & IA · Santé et Sécurité",
  hero_cta: "Découvrir nos services",

  // Home services
  home_services_label: "Nos domaines",
  home_services_title: "Cinq secteurs d'expertise",
  home_learn_more: "En savoir plus",

  // Home service cards
  svc_construction_title: "Construction",
  svc_construction_desc: "Bâtiments, ponts, structures métalliques et ouvrages de génie civil.",
  svc_tp_title: "Travaux Publics",
  svc_tp_desc: "Routes, réseaux d'eau, assainissement et aménagements publics.",
  svc_logistique_title: "Transport & Logistique",
  svc_logistique_desc: "Location d'engins, transport de matériaux et approvisionnement.",
  svc_sst_title: "Santé & Sécurité",
  svc_sst_desc: "Audits sécurité, équipements de protection et formations SST.",
  svc_digital_title: "Solutions Digitales & IA",
  svc_digital_desc: "Développement logiciel, analyse de données, machine learning, BI et transformation digitale des entreprises.",

  // Home figures
  fig_trades: "Corps de métiers",
  fig_congolese: "Capitaux congolais",
  fig_sectors: "Secteurs d'activité",
  fig_projects: "Projets réalisés",

  // About
  about_title: "Bâtir l'avenir du Congo, un projet à la fois",
  about_subtitle: "RACHEVANE SARL - Enseigne RAVA",
  about_p1: "RACHEVANE SARL, opérant sous l'enseigne RAVA, est une société congolaise à responsabilité limitée dont le siège social est établi au n°08, avenue Savonnier, quartier Bel-Air, commune de Kampemba, ville de Lubumbashi, province du Haut-Katanga, République Démocratique du Congo.",
  about_p2: "Constituée intégralement à capitaux congolais, RAVA SARL s'est imposée comme un acteur incontournable dans les secteurs de la construction, des travaux publics et de l'ingénierie en RDC. L'entreprise porte une vision ambitieuse : contribuer au développement durable des infrastructures congolaises à travers l'excellence opérationnelle et l'innovation.",
  about_p3: "RAVA SARL a élargi son champ d'expertise en intégrant un pôle dédié aux solutions digitales et à l'intelligence artificielle. En collaboration avec des experts issus de l'Université McGill et d'Omics Data Solutions Inc., l'entreprise accompagne ses clients dans leur transformation numérique, du développement de logiciels sur mesure à l'implémentation de modèles de machine learning, en passant par la mise en place de plateformes d'analyse de données.",
  about_p4: "Cette double expertise en ingénierie traditionnelle et en innovation technologique positionne RAVA SARL comme un partenaire stratégique unique, capable de répondre aux défis les plus complexes du développement congolais.",
  about_p5: "RAVA SARL est régie par les dispositions de l'Acte Uniforme OHADA relatif au droit des sociétés commerciales et du groupement d'intérêt économique, ainsi que par l'ensemble des dispositions légales et réglementaires en vigueur en République Démocratique du Congo.",
  about_legal: "Informations légales",
  about_values_label: "Nos principes",
  about_values_title: "Six valeurs fondatrices",
  val_quality: "Qualité",
  val_quality_desc: "Chaque ouvrage est livré avec un niveau d'exécution irréprochable, sans compromis sur les matériaux ni les finitions.",
  val_safety: "Sécurité",
  val_safety_desc: "La protection de nos équipes et partenaires est une priorité absolue sur chaque chantier.",
  val_innovation: "Innovation",
  val_innovation_desc: "Nous intégrons les méthodes et technologies les plus avancées pour répondre aux défis de chaque projet.",
  val_deadlines: "Respect des délais",
  val_deadlines_desc: "Nos engagements calendaires sont tenus. Un projet livré à temps est un gage de confiance et de sérieux.",
  val_environment: "Environnement",
  val_environment_desc: "Des pratiques responsables sont intégrées dans chacune de nos interventions sur le terrain.",
  val_satisfaction: "Satisfaction client",
  val_satisfaction_desc: "Nous travaillons jusqu'à obtenir un résultat pleinement conforme aux attentes de nos clients.",
  about_partners_label: "Partenaires",
  about_partners_title: "Nos partenaires stratégiques",
  about_partners_text: "RAVA collabore avec des institutions et entreprises de premier plan pour garantir l'excellence de ses services.",

  // Services listing
  services_title: "Nos services",
  services_description: "Cinq secteurs d'expertise pour répondre à l'ensemble de vos besoins en construction, infrastructure et technologie.",

  // Service detail
  svc_detail_highlights: "Ce que nous proposons",
  svc_detail_process: "Notre processus",
  svc_detail_cta_title: "Besoin de ce service ?",
  svc_detail_cta_text: "Contactez-nous pour un devis gratuit. Réponse sous 24h.",
  svc_detail_cta_button: "Demander un devis",
  svc_detail_others: "Autres services",

  // Realisations
  real_title: "Réalisations",
  real_description: "Une sélection de projets qui témoignent de notre savoir-faire et de notre rigueur technique.",
  real_filter_all: "Tous",

  // Contact
  contact_title: "Contact",
  contact_description: "Démarrons votre projet ensemble. Devis gratuit sous 24h.",
  contact_info_label: "Coordonnées",
  contact_form_title: "Demande de devis",
  contact_form_subtitle: "Réponse sous 24h ouvrables.",
  contact_name: "Nom complet",
  contact_email: "Email",
  contact_phone: "Téléphone",
  contact_budget: "Budget estimé",
  contact_budget_select: "Sélectionnez",
  contact_budget_10: "Moins de 10 000 $",
  contact_budget_50: "10 000 - 50 000 $",
  contact_budget_200: "50 000 - 200 000 $",
  contact_budget_plus: "Plus de 200 000 $",
  contact_service: "Type de service",
  contact_service_select: "Sélectionnez un service",
  contact_message: "Description du projet",
  contact_message_placeholder: "Décrivez votre projet...",
  contact_submit: "Envoyer la demande",
  contact_sending: "Envoi en cours...",
  contact_success_title: "Message envoyé",
  contact_success_text: "Nous vous répondrons dans les plus brefs délais.",
  contact_success_again: "Envoyer un autre message",
  contact_error: "Une erreur s'est produite. Veuillez réessayer.",
  contact_whatsapp: "Écrire sur WhatsApp",
  contact_required: "*",

  // Footer
  footer_tagline: "Quality In Every Build",
  footer_location: "Lubumbashi, Haut-Katanga, RDC",
  footer_nav: "Navigation",
  footer_services: "Services",
  footer_contact: "Contact",
  footer_rights: "RAVA. Tous droits réservés.",

  // 404
  notfound_title: "Page introuvable",
  notfound_back: "Retour à l'accueil",
};

export default fr;
